import React from "react";
export const ListingLoader = ({ append, children, className, isLoading, skeletonCount, SkeletonTile, }) => (React.createElement("div", { className: className }, isLoading ? (React.createElement(React.Fragment, null,
    append && children,
    Array.from({ length: skeletonCount }, (_, i) => `skeleton-${i}`).map((key) => (React.createElement(SkeletonTile, { key: key }))))) : (children)));
